import { ContentApiContentCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useContentCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: ContentApiContentCreateRequest, config) =>
      appApiClient.contentApi.contentCreate(req, config),
  });
